import React, { Component } from 'react';
import { getClass } from '../_lib/helper';
import { Badge, Heading, Paragraph, Text } from '../main';
import { CardProps } from './type';
import './Card.scss';

class Card extends Component<CardProps> {
  renderBadges() {
    const { id, badges } = this.props;
    const keyTemplate = 'card-badge-' + id + '-';
    return (
      badges &&
      badges.map((badge, index) => {
        return (
          <Badge
            icon={badge.icon}
            type={badge.type}
            role={badge.role}
            key={keyTemplate + index}
            data-test-id={keyTemplate + index}
          >
            {badge.children}
          </Badge>
        );
      })
    );
  }

  handleClick = () => {
    const { onClick } = this.props;
    if (onClick) {
      onClick();
    }
    return false;
  };
  handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      this.handleClick();
    }
  };

  render() {
    const {
      id,
      heading,
      children,
      description,
      className,
      isFullHeight,
      option,
      prefix,
      image,
      imageAlt,
      badges,
      onClick,
      role,
      fullWidthHeader,
    } = this.props;

    const backgroundImage = image
      ? { backgroundImage: 'url(' + image + ')' }
      : undefined;
    const shouldShowHeaderImage = image || badges || fullWidthHeader;

    return (
      <div
        role={role}
        id={id}
        data-testid={`elmo-card-${id || 'default'}`}
        className={getClass('elmo-card', className, {
          'is-full-height': isFullHeight,
          'is-clickable': onClick,
        })}
        onClick={onClick ? this.handleClick : undefined}
        onKeyPress={this.handleKeyPress}
        tabIndex={onClick ? 0 : undefined}
      >
        {shouldShowHeaderImage && (
          <div
            className="elmo-card__header-image"
            title={image && imageAlt}
            style={{ ...backgroundImage }}
            role="img"
            aria-label={image && imageAlt}
          >
            {fullWidthHeader && <div>{fullWidthHeader}</div>}
            <div className="elmo-card__header-badges">
              {this.renderBadges()}
            </div>
          </div>
        )}

        {(prefix || heading || description || option) && (
          <div className="elmo-card__header">
            {option && <div className="elmo-card__option">{option}</div>}
            {heading && (
              <Heading className="elmo-card__heading">
                {prefix && (
                  <Text
                    size="sm"
                    color="gray"
                    htmlTag="small"
                    className="d-block mb-2 elmo-card__heading-prefix"
                  >
                    {prefix}
                  </Text>
                )}
                {heading}
              </Heading>
            )}
            {description && <Paragraph>{description}</Paragraph>}
          </div>
        )}
        <div className="elmo-card__content">
          <div className="elmo-card__content-inner">{children}</div>
        </div>
      </div>
    );
  }
}

export default Card;
